import "./style.css";

import { IWatch } from "../../../../../interfaces/watch";

interface IYoutubeProps {
  watchInfo: IWatch;
}

const Youtube: React.FC<IYoutubeProps> = ({ watchInfo }) => {
  return (
    <iframe
      className="youtube-wrappper"
      src={watchInfo.url}
      title={watchInfo.title}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    />
  );
};

export default Youtube;
